/** True if the string looks like an email address. */
export function looksLikeEmail(value) {
  const s = String(value ?? '').trim();
  return s.includes('@');
}

/** Title-case a single word or phrase from an email local part. */
function nameFromEmailLocal(email) {
  const local = String(email).split('@')[0] || '';
  const spaced = local.replace(/[._-]+/g, ' ').trim();
  if (!spaced) return '';
  return spaced.replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Display name for posts, replies, and composers.
 * Never shows a full email when first/last name are available or derivable.
 */
export function getAuthorDisplayName(item) {
  if (!item) return 'Member';

  const first = item.first_name || item.firstname || '';
  const last = item.last_name || item.lastname || '';
  const full = [first, last].filter(Boolean).join(' ').trim();
  if (full) return full;

  for (const candidate of [item.author_name, item.username]) {
    const c = String(candidate ?? '').trim();
    if (c && !looksLikeEmail(c)) return c;
  }

  if (item.email && looksLikeEmail(item.email)) {
    const fromEmail = nameFromEmailLocal(item.email);
    if (fromEmail) return fromEmail;
  }

  return 'Member';
}

/** Display name for users in the "Liked by" list and reaction summary. */
export const getLikerDisplayName = getAuthorDisplayName;

/** Build post/reply meta line: date · category · position · country */
export function formatAuthorMetaLine(item, formatDate) {
  if (!item) return '';
  const datePart =
    typeof formatDate === 'function' && item.created_at
      ? formatDate(item.created_at)
      : item.created_at || '';
  return [datePart, item.category, item.position, item.country]
    .map((part) => String(part ?? '').trim())
    .filter(Boolean)
    .join(' · ');
}

